import { prefix } from './_config'

import { request } from '@/utils/request'

// 产品列表
export function getProductList(data) {
  return request({
    url: prefix + '/page',
    method: 'post',
    data
  })
}

// 编辑产品
export function updateProduct(data) {
  return request({
    url: prefix + '/update',
    method: 'post',
    data
  })
}

// 新增产品
export function addProduct(data) {
  return request({
    url: prefix + '/add',
    method: 'post',
    data
  })
}

// 所有产品渠道列表
export function getAllProductChannelList(data) {
  return request({
    url: prefix + '/channel/all',
    method: 'post',
    data
  })
}

// 产品渠道列表
export function getProductChannelList(data) {
  return request({
    url: prefix + '/channel/page',
    method: 'post',
    data
  })
}

// 新增产品渠道列表
export function addProductChannel(data) {
  return request({
    url: prefix + '/channel/add',
    method: 'post',
    data
  })
}

// 编辑产品渠道列表
export function updateProductChannel(data) {
  return request({
    url: prefix + '/channel/update',
    method: 'post',
    data
  })
}

// 编辑产品渠道列表
export function deleteProductChannel(data) {
  return request({
    url: prefix + '/channel/del',
    method: 'post',
    data
  })
}
